import { useQuery } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';
import { mapPersonasToOptions, personasQuery, type PersonaOption } from '@/entities/persona';
import { useWorkspaceTagSuggestions } from '@/entities/project-tag';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import type { CreateProjectFormData } from '@/features/create-project/model/schema';

export function useReviewDetailsStep() {
  const { control, formState } = useFormContext<CreateProjectFormData>();
  const workspaceId = useCurrentWorkspaceId();
  const { data: personas = [] } = useQuery(personasQuery(workspaceId ?? undefined));
  const { suggestions: tagOptions } = useWorkspaceTagSuggestions(workspaceId);

  const personaOptions = mapPersonasToOptions(personas);

  const getPersonaById = (id: string): PersonaOption | undefined =>
    personaOptions.find((p) => p.id === id);

  return {
    control,
    isSubmitting: formState.isSubmitting,
    tagOptions,
    personaOptions,
    getPersonaById,
  };
}
